import BaseWidget from 'scripts/base-widget';

import view from './alert-manager.stache';

export const AlertManager = BaseWidget.extend({
    init() {
        this.$element.append(view());
        this._super();
    },
});
